var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-dialogs"},_vm._l((_vm.items),function(item){return _c('v-dialog',{key:item.key,attrs:{"show":item.show,"item":item},on:{"close":_vm.onClose}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }